import * as markedModule from 'marked'; // This is to allow us to stub this module in tests.

export var marked = markedModule.default;